import { render, staticRenderFns } from "./FormSalva.vue?vue&type=template&id=31760184&scoped=true"
import script from "./FormSalva.vue?vue&type=script&lang=js"
export * from "./FormSalva.vue?vue&type=script&lang=js"
import style0 from "./FormSalva.vue?vue&type=style&index=0&id=31760184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31760184",
  null
  
)

export default component.exports